// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for MedicationUnit model structure.
 * @see #/components/schemas/MedicationUnit - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface MedicationUnit {
    /**
     * The Medication Unit Identifier.
     * @dataFormat uuid
     */
    readonly id: string;
    /**
     * The Unit of the Medication.
     *
     */
    unit: string;
    /**
     * The medication category code.
     *
     */
    medication_category: string;
    /**
     * The Unified Code for Units of Measure (UCUM).
     *
     */
    ucum_code?: string | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for MedicationUnit
 */
export namespace MedicationUnit {
    /**
     * MedicationUnit Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The Medication Unit Identifier.
         * @dataFormat uuid
         */
        readonly id: string;
        /**
         * The Unit of the Medication.
         * @type string (`dataFormat` is missing)
         */
        unit: string;
        /**
         * The medication category code.
         * @type string (`dataFormat` is missing)
         */
        medicationCategory: string;
        /**
         * The Unified Code for Units of Measure (UCUM).
         * @type string (`dataFormat` is missing)
         */
        ucumCode?: string | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * MedicationUnit DTO
     * Transforms MedicationUnit model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend MedicationUnit model */
        static toModel(obj: MedicationUnit): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend MedicationUnit model */
        static toApi(obj: Model): MedicationUnit {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as MedicationUnit;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
